export default __webpack_public_path__ + "static/media/premium-waiver-icon.03f194a0.svg";